import type { ComponentSchema } from "../../../../../schema-types";
import { SECTION_STYLE_FIELDS } from "../../_builder-constants";

export const schema: ComponentSchema = {
  type: "cta",
  label: "Call to Action",
  description: "A full-width picture banner with a link, or an accent band with a headline and a quote card.",
  supportedPages: ["home", "shop", "categories", "about", "contact"],
  variants: [
    {
      id: "v1",
      label: "Picture banner",
      fields: [
        { key: "image", label: "Picture", type: "image", help: "Wide, about 1240 × 200 px; may carry its own artwork." },
        { key: "mobileImage", label: "Phone picture", type: "image", help: "Optional, about 780 × 340 px." },
        { key: "link", label: "Link", type: "string", default: "/contact" },
        { key: "title", label: "Heading (optional)", type: "string", default: "Become a reseller" },
        { key: "subtitle", label: "Line (optional)", type: "string", default: "Sell our shoes and earn on every order." },
        { key: "buttonText", label: "Button text (optional)", type: "string", default: "Join now" },
      ],
    },
    {
      id: "v2",
      label: "Quote band",
      fields: [
        { key: "eyebrow", label: "Eyebrow", type: "localized-string", default: "What comes next" },
        { key: "title", label: "Headline", type: "string", default: "From our street" },
        { key: "outline", label: "Second line", type: "localized-string", default: "to yours.", help: "On its own line under the headline, in a lighter weight." },
        { key: "subtitle", label: "Paragraph", type: "text", default: "We want to keep finding shoes that fit well, last long and cost fairly, for more feet in more cities." },
        { key: "quote", label: "Quote", type: "localized-string", default: "Wear it loud." },
        { key: "quoteText", label: "Line under the quote", type: "localized-text", default: "More than a slogan: the reason every pair is checked before it ships." },
      ],
    },
  ],
  commonFields: [...SECTION_STYLE_FIELDS],
};
